/* global tinymce */
import Bugsnag from '@bugsnag/js'

import Cleaner from './cleaner'

tinymce.PluginManager.add('groove-before-set-content-cleanup', editor => {
  const configValidStyles = editor.settings?.valid_styles
  let parsedValidStyles

  if (configValidStyles) {
    parsedValidStyles = {}
    Object.keys(configValidStyles).forEach(tagName => {
      parsedValidStyles[tagName] = configValidStyles[tagName]
        .split(',')
        .map(styleName => {
          return styleName.trim()
        })
    })
  }

  /**
   * Fired before the content is parsed and rendered in the editor.
   * https://www.tiny.cloud/docs/advanced/events/#editorcoreevents
   */
  editor.on('BeforeSetContent', e => {
    const { content, format } = e

    // don't wanna open the floodgates just yet, bugsnag notify below will inform us if we need to add more
    const isValidContentType = ['html', 'raw'].includes(format)

    if (!isValidContentType) {
      Bugsnag.notify(
        new Error('tinymce-BeforeSetContent: unknown content type'),
        event => {
          event.severity = 'info'
          event.addMetadata('metaData', {
            meta: {
              format,
              content,
            },
          })
        }
      )
    }

    if (!content || !isValidContentType) return

    // Helply Copilot inserts semantic <p> paragraphs and relies on the editor's
    // own `p { margin-bottom }` to space them (see HelplyCopilotPanel). The
    // default p→div replacement would strip that margin, so for those inserts
    // only — flagged on the editor instance around the insert/set call (TinyMCE
    // 4's insertContent doesn't forward custom event args, so a per-call arg
    // can't reach here; this BeforeSetContent handler fires synchronously during
    // the call, so the instance flag is reliable) — keep <p> as <p>.
    // Typed/pasted content is unflagged and still normalizes to <div>.
    const keepParagraphs = editor.helplyKeepParagraphs === true

    try {
      const cleaner = new Cleaner({
        remove: ['meta', 'input', 'button', 'style'],
        unwrap: ['span'],
        replace: keepParagraphs ? {} : { p: 'div' },
        removeClasses: true,
        removeStyles: true,
        validStyles: parsedValidStyles,
      })

      const contentAfterCleanup = cleaner.cleanup(content)

      if (
        contentAfterCleanup &&
        contentAfterCleanup.trim() === '' &&
        content.trim() !== ''
      ) {
        Bugsnag.notify(
          new Error(
            'tinymce-BeforeSetContent-cleaner: content cleared after clean'
          ),
          event => {
            event.severity = 'info'
            event.addMetadata('metaData', {
              meta: {
                format,
                content,
                contentAfterCleanup,
              },
            })
          }
        )
      }

      e.content = contentAfterCleanup
    } catch (err) {
      Bugsnag.notify(err, event => {
        event.severity = 'error'
        event.addMetadata('metaData', {
          meta: {
            format,
            content,
            contentAfterCleanup,
          },
        })
      })
    }
  })

  return {
    getMetadata() {
      return {
        name:
          'Groove cleanup HTML content before it is parsed and rendered in the editor.',
      }
    },
  }
})

export default {}
